module.exports = __webpack_public_path__ + "img/village_capital.d7bf68d1.png";